import { render } from "./Panier.vue?vue&type=template&id=4c45ff34&scoped=true"
import script from "./Panier.vue?vue&type=script&lang=js"
export * from "./Panier.vue?vue&type=script&lang=js"

import "./Panier.vue?vue&type=style&index=0&id=4c45ff34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c45ff34"]])

export default __exports__